module.exports = __webpack_public_path__ + "img/turbo-features3.dc39a4cc.png";